import { render, staticRenderFns } from "./BookView.vue?vue&type=template&id=edb175b4"
import script from "./BookView.vue?vue&type=script&lang=js"
export * from "./BookView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports